export const DEFAULT_ERROR_TEXT =
  'Служба записи на прием временно недоступна. Пожалуйста, повторите запрос позднее.';
export const CANCEL_SUCCESS_TEXT = 'Данное посещение налогового органа было отменено';
